"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var preact_1 = require("preact");
var react_1 = require("swiper/react");
var SwiperNavArrows_1 = require("../../Swiper/SwiperNavArrows");
var modules_1 = require("swiper/modules");
var Parser_1 = require("../Parser");
var BeforeAfterCarouselMain = function (_a) {
    var reviews = _a.reviews, color = _a.color, stars = _a.stars;
    var isMobile = window.innerWidth < 768 ? true : false;
    var modules = [modules_1.Navigation];
    var shouldLoop = false;
    if (reviews.length > 4 || isMobile) {
        shouldLoop = true;
        modules.push(modules_1.Pagination);
    }
    return ((0, preact_1.h)(preact_1.Fragment, null,
        (0, preact_1.h)(react_1.Swiper, { className: "before-after-carousel swiper-carousel--".concat(color), modules: modules, pagination: { clickable: true }, slidesPerView: 1.3, loop: shouldLoop, resizeObserver: true, centeredSlides: shouldLoop, centerInsufficientSlides: shouldLoop, breakpoints: {
                768: {
                    slidesPerView: 2,
                },
                1025: {
                    slidesPerView: shouldLoop ? 3.4 : 4,
                },
            } },
            shouldLoop && (0, preact_1.h)(SwiperNavArrows_1.default, { color: color }),
            reviews.map(function (review, index) { return ((0, preact_1.h)(react_1.SwiperSlide, { key: index },
                (0, preact_1.h)("div", { class: "before-after-carousel__parent-container" },
                    (0, preact_1.h)("div", { class: "before-after-carousel__image-container" },
                        (0, preact_1.h)("img", { class: "before-after-carousel__image", src: review.backgroundImg, loading: window.isLazyVPTest ? 'lazy' : 'eager' })),
                    (0, preact_1.h)("div", { class: "before-after-carousel__text-container" },
                        (0, preact_1.h)("img", { class: "before-after-carousel__review-stars", src: stars, alt: "review stars" }),
                        (0, preact_1.h)("p", { class: "before-after-carousel__review-text" }, (0, Parser_1.parse)(review.body)),
                        (0, preact_1.h)("div", { class: "before-after-carousel__bottom-container" },
                            (0, preact_1.h)("p", { class: "before-after-carousel__review-author" },
                                " - ",
                                review.author),
                            (0, preact_1.h)("p", { class: "before-after-carousel__verified" }, " Verified")))))); }))));
};
exports.default = BeforeAfterCarouselMain;
